const MuiSelect = {
  root: {
    '&&:focus': {
      backgroundColor: 'transparent',
    },
  },
};

export default MuiSelect;
